<template>
  <div
    :class="background"
    class="testimonials-carousel critical-component-clear section-content-padding"
  >
    <div class="container testimonials-carousel__container">
      <button
        :aria-label="$string('accessibility.carousel.previous')"
        :class="`swiper-button-prev-${liquid.sectionId}`"
        class="swiper-arrow swiper-button-prev dark"
      >
        <span
          class="button__icon button-icon"
          v-html="$icon('enclosed.chevron.left')"
        />
      </button>

      <swiper
        :instance-name="liquid.sectionId"
        :loop="true"
        :autoHeight="true"
        :modules="modules"
        :navigation="navigation"
        :pagination="{ clickable: true }"
        :autoplay="autoPlay"
        class="testimonials-carousel__carousel"
      >
        <swiper-slide
          v-for="(block, index) in testimonials"
          :id="`testimonial-carousel-slide--${index}-${liquid.sectionId}`"
          :key="`testimonial-carousel-slide-${index}`"
          class="testimonial-carousel__slide"
        >
          <testimonial
            :author="block.settings.author"
            :eyebrow-bullet="block.settings.eyebrow_bullet"
            :eyebrow-copy="block.settings.eyebrow"
            :quote="block.settings.quote"
            :highlighter-color="block.settings.highlighter_color"
          />
        </swiper-slide>
      </swiper>

      <button
        :aria-label="$string('accessibility.carousel.next')"
        :class="`swiper-button-next-${liquid.sectionId}`"
        class="swiper-arrow swiper-button-next dark"
      >
        <span
          class="button__icon button-icon"
          v-html="$icon('enclosed.chevron.right')"
        />
      </button>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Testimonials carousel (testimonials-carousel)
 * -----------------------------------------------------------------------------
 * A carousel of testimonials.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */

import Testimonial from '~async/testimonials-carousel/testimonial/testimonial'

import { Swiper, SwiperSlide } from 'swiper/vue'
import { A11y, Navigation, Pagination, Autoplay } from 'swiper'

export default {
  name: 'TestimonialsCarousel',
  components: {
    Swiper,
    SwiperSlide,
    Testimonial,
  },

  props: {
    background: {
      type: String,
      default: '',
    },
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        blocks: [],
        settings: {
          rotation: {
            type: Boolean,
            default: false,
          },
        },
        rotationTime: {
          type: Number,
          default: 0,
        },
      }),
    },
  },

  setup(props) {
    return {
      modules: [
        A11y,
        Navigation,
        Pagination,
        Autoplay,
      ],
      navigation: {
        prevEl: `.swiper-button-prev-${props.liquid.sectionId}`,
        nextEl: `.swiper-button-next-${props.liquid.sectionId}`,
      },
    }
  },

  data() {
    return {}
  },

  computed: {

    /**
     * Filter out empty testimonials
     * @returns {Array}
     */
    testimonials() {
      return this.liquid.blocks?.filter(block => block?.settings.quote) || []
    },

    /**
     * Check if rotation disabled and assign correct delay.
     * @returns {boolean|{delay: {default: number, type: Number | NumberConstructor}}}
     */
    autoPlay(){
      if (!this.liquid.settings.rotation) {
        return false
      }
      return { delay: this.liquid.rotationTime }
    },
  },

  mounted() {

  },

  methods: {},
}
</script>

<style lang="scss">
@import './testimonials-carousel';
</style>
